// src/pages/exercise/components/Character/TransitionController.jsx
import { useFrame } from '@react-three/fiber';
import { useStore } from '../Stores/exerciseStore';
import * as THREE from 'three';
import { useRef, useEffect } from 'react';

const charCurve = new THREE.CubicBezierCurve3(
  new THREE.Vector3(0, 0, 0),      // Start  
  new THREE.Vector3(0, -1, 2),     // Jump Apex
  new THREE.Vector3(0, -2, 0),     // Fall
  new THREE.Vector3(0, 0, -20)     // Land
);

const cameraCurve = new THREE.CubicBezierCurve3(
  new THREE.Vector3(0, -1.5, 0.8),     // ✅ START — initial position
  new THREE.Vector3(0, -2.5, 3),       // Jump Apex
  new THREE.Vector3(0, -3.5, 1),       // Fall  
  new THREE.Vector3(0, -1.5, -19.1)    // Land
);

export function TransitionController({ charGroupRef }) {
  const phase = useStore((state) => state.phase);
  const t = useRef(0);
  const hasCompleted = useRef(false); // ← NEW

  useEffect(() => {
    console.log('[TransitionController] Phase changed to:', phase);
  }, [phase]);


  useFrame((state, delta) => {
    // === TRANSITION1: Jump DOWN ===
    if (phase === 'TRANSITION1') {
      t.current += delta * 0.5;
      
      if (t.current >= 1) {
        t.current = 1;
        
        if (!hasCompleted.current) { // ← FIRE ONCE ONLY
          hasCompleted.current = true;
          useStore.getState().completeTransitionImmediate();
          console.log('[TransitionController] ✅ TRANSITION1 complete IMMEDIATE');
        }
      }

      // Move character
      if (charGroupRef.current) {
        const charPoint = charCurve.getPointAt(t.current);
        charGroupRef.current.position.copy(charPoint);
      }

      // Move camera
      const camPoint = cameraCurve.getPointAt(t.current);
      state.camera.position.copy(camPoint);

      // Camera lookAt
      if (charGroupRef.current) {
        const target = charGroupRef.current.position.clone();
        target.z += 0.7;
        state.camera.lookAt(target);
      }
    }
    
    // === TRANSITION2: Jump UP ===
    else if (phase === 'TRANSITION2') {
      t.current += delta * 0.5;
      
      if (t.current >= 1) {
        t.current = 1;
        
        if (!hasCompleted.current) {
          hasCompleted.current = true;
          useStore.getState().completeTransitionImmediate();
          console.log('[TransitionController] ✅ TRANSITION2 complete IMMEDIATE');
        }
      }

      // Move character (REVERSE)
      if (charGroupRef.current) {
        const charPoint = charCurve.getPointAt(1 - t.current);
        charGroupRef.current.position.copy(charPoint);
      }

      // Move camera (REVERSE)
      const camPoint = cameraCurve.getPointAt(1 - t.current);
      state.camera.position.copy(camPoint);

      // Camera lookAt
      if (charGroupRef.current) {
        const target = charGroupRef.current.position.clone();
        target.z += 0.7;
        state.camera.lookAt(target);
      }
    }
    
    // === Reset when NOT transitioning ===
    else {
      if (t.current !== 0) {
        console.log('[TransitionController] Resetting t to 0');
        t.current = 0;
      }
      hasCompleted.current = false; // ← RESET for next transition
    }
  });

  return null;
}